import { find } from 'lodash'

import { MachinesMainGridController as BaseController, dependencies as ControllerDependencies } from '../../../../common/Pages/Main/Grid/controller'
import { MachinesMainGridConfig } from '../../../../common/Pages/Main/Grid/config'

import template from './index.html'

class MachinesMainGridController
  extends BaseController {
  getColumnDefs() {
    const columnDefs = super.getColumnDefs()

    const statusColumn = find(columnDefs, colDef => colDef.field === 'Status')
    const gameTypeColumn = { headerName: 'Game Type', field: 'GameType', editable: false, suppressMenu: true }
    const gameTypeLocation = columnDefs.indexOf(statusColumn) - 1

    const gameThemeColumn = { headerName: "Game Theme", field: "GameTheme", editable: false, suppressMenu: true}

    columnDefs.splice(gameTypeLocation, 0, gameTypeColumn, gameThemeColumn)

    const gameNameColumn = find(columnDefs, colDef => colDef.field === 'GameName')
    const gameNameLocation = columnDefs.indexOf(gameNameColumn)

    columnDefs.splice(gameNameLocation, 1)


    return columnDefs
  }

  afterInit() {
    super.afterInit()
    this.showEpromReport = false
  }
}
MachinesMainGridController.$inject = ControllerDependencies

export default function machinesMainGridControllerConfig() {
  MachinesMainGridConfig.GridController = MachinesMainGridController
  MachinesMainGridConfig.templateUrl = template
}
machinesMainGridControllerConfig.vsNgType = 'config'
machinesMainGridControllerConfig.vsName = 'machinesMainGridControllerConfig'
